import React, { useEffect, useRef } from 'react';
import {TakisSpanStyles, colorVariations} from './TakisSpan.style'
import PropTypes from 'prop-types';

export default function TakisSpan(props) {
  const classes = colorVariations();

  const {
    modifier,
    title,
    alt,
    color,
    orientation,
    sendButton,
    imageContent
  } = props

  // exposing the button element ref
  const button = useRef(null);
  useEffect(()=>{
    if (button) {
      if (sendButton) {
        sendButton(button)
      }
    }
  }, [button,sendButton])


  TakisSpan.propTypes = {
    title: PropTypes.string.isRequired,
    alt: PropTypes.string,
    modifier: PropTypes.string,
    color: PropTypes.string,
    orientation:PropTypes.string,
    btnFunc: PropTypes.func,
    imageContent: PropTypes.string
  };
  return (
    <TakisSpanStyles disableRipple
      className={`
        ${classes[color]}
        ${orientation && classes[orientation]}
        ${modifier || ''}${imageContent ? classes.amazonBtn : ''}
      `}
      title={title}
      {...props}
      >
        {imageContent
          ? <img src={imageContent} alt={alt}/>
          : title
        }
    </TakisSpanStyles>
    );
}
